import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card-toolbar",
  "data-bs-toggle": "tooltip",
  "data-bs-placement": "top",
  "data-bs-trigger": "hover",
  title: "Click to add make a note"
}
const _hoisted_2 = {
  key: 0,
  href: "#",
  class: "btn btn-sm btn-primary",
  "data-bs-toggle": "modal",
  "data-bs-target": "#kt_modal_review_note"
}
const _hoisted_3 = { class: "svg-icon svg-icon-3" }
const _hoisted_4 = {
  class: "modal fade",
  id: "kt_modal_review_note",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_5 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_6 = { class: "modal-content rounded" }
const _hoisted_7 = { class: "modal-header pb-0 border-0 justify-content-end" }
const _hoisted_8 = {
  class: "btn btn-sm btn-icon btn-active-color-primary",
  "data-bs-dismiss": "modal"
}
const _hoisted_9 = { class: "svg-icon svg-icon-1" }
const _hoisted_10 = { class: "modal-body scroll-y px-10 px-lg-15 pt-0 pb-15" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "mb-13 text-center" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "mb-3" }, "IRB Application - Review Note")
], -1)
const _hoisted_12 = { class: "row mb-6" }
const _hoisted_13 = { class: "col-lg-12 fv-row" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Note:"),
  /*#__PURE__*/_createElementVNode("i", {
    class: "fas fa-exclamation-circle ms-2 fs-7",
    "data-bs-toggle": "tooltip",
    title: "note"
  })
], -1)
const _hoisted_15 = { class: "text-center" }
const _hoisted_16 = ["loading"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("button", {
  type: "reset",
  id: "kt_modal_add_co_investigator_cancel",
  class: "btn btn-white me-3"
}, " Clean ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (
          _ctx.allowCreateNote
        )
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (
            _ctx.allowCreateNote
          )
            ? (_openBlock(), _createElementBlock("a", _hoisted_2, [
                _createElementVNode("span", _hoisted_3, [
                  _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr075.svg" })
                ]),
                _createTextVNode(" Review Note " + _toDisplayString(_ctx.propType), 1)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("span", _hoisted_9, [
                _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr061.svg" })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_el_form, {
              id: "kt_modal_new_target_form",
              model: _ctx.formData,
              ref: "formRef",
              class: "form"
            }, {
              default: _withCtx(() => [
                _hoisted_11,
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _hoisted_14,
                    _createVNode(_component_el_form_item, { prop: "description" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.formData.note,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.note) = $event)),
                          type: "textarea",
                          rows: "3",
                          name: "note",
                          placeholder: "Type Notes"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "primary btn btn-primary",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.submit())),
                    loading: _ctx.loading
                  }, _toDisplayString(_ctx.loading ? "Please wait..." : "Submit"), 9, _hoisted_16),
                  _hoisted_17
                ])
              ]),
              _: 1
            }, 8, ["model"])
          ])
        ])
      ])
    ])
  ], 64))
}